import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.5, delay, ease: "easeOut" }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

// Light page hero — white/surface background, navy headline, gray subtext.
export function PageHero({ eyebrow, title, subtitle }) {
  return (
    <section className="border-b border-border bg-surface">
      <div className="container-pn py-20 md:py-28">
        {eyebrow && <p className="label-eyebrow">{eyebrow}</p>}
        <h1 className="mt-4 max-w-3xl font-heading text-4xl font-black tracking-tight text-navy sm:text-5xl">
          {title}
        </h1>
        {subtitle && <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground/70">{subtitle}</p>}
      </div>
    </section>
  );
}

export function SectionHeading({ eyebrow, title, subtitle, center }) {
  return (
    <div className={center ? "text-center" : ""}>
      {eyebrow && <p className="label-eyebrow">{eyebrow}</p>}
      <h2 className={`mt-3 font-heading text-3xl font-bold tracking-tight text-navy sm:text-4xl ${center ? "mx-auto" : ""} max-w-2xl`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 max-w-2xl text-base text-foreground/70 ${center ? "mx-auto" : ""}`}>{subtitle}</p>
      )}
    </div>
  );
}
